module.exports = __webpack_public_path__ + "img/cart-empty.af48ee05.svg";